export default __webpack_public_path__ + "5737d52d2af3d6917a09355e64451167.svg";